import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiArrowLeft, HiDotsVertical, HiOutlinePlus } from 'react-icons/hi'
import { BsFillCalendarWeekFill } from 'react-icons/bs'
import { GiCancel } from 'react-icons/gi'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnsTable, IDealer, IPurchase, IUnit } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { PdfViewProps } from '../../components/Display/PdfView'
import Table from '../../components/Display/Table'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { HeaderProps } from '../../components/Layout/Header'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { fetchPurchases } from '../../redux/actions/purchases'
import { RootState } from '../../redux/store'
import {
  dateToDB,
  formatAmount,
  formatPipe,
  formatToBs,
  getDenomination,
  getIvaNumber,
  getMissing,
  getYearMonthAndDay,
  transformDate,
} from '../../utils/utils'
import Purchase from './Purchase/Purchase'
import PurchasesSearchModal, {
  PurchaseSearch,
} from './Purchase/PurchasesSearchModal'
import FloatingForm from '../../components/Display/FloatingForm'
import axios from 'axios'
import AdvancedPurchaseForm from '../../components/Display/AdvancedPurchaseForm'
import EditPurchaseForm from './Purchase/EditInvoiceForm'
import { onGetFileFromS3, uploadToS3, downloadImage } from '../../utils/UploadFile'
import ModalConfirm from '../../components/Display/ModalConfirm'
import WatchPurchase from './Purchase/WatchPurchase'
import AddPayments from './Purchase/AddPayments'
import AddReceivableProduct from './Purchase/AddReceivableProduct'
import Return from './Purchase/Return'
import PdfSale from '../Sells/PdfSale'
import { IGlobalRate } from '../Sells/Sells'
import { fetchWarehouses } from '../../redux/actions/warehouses'
import { fetchCategories } from '../../redux/actions/categories'
import AddPaymentForm from './Purchase/AddPaymentForm'
import DealersForm from '../Dealers/DealersForm'
import {
  createDealer,
  fetchDealers,
  updateDealer,
} from '../../redux/actions/dealers'
import AddPaymentFormModal from './Purchase/AddPaymentFormModal'
import { DateTime } from 'luxon'
import { toFixed } from 'accounting'
import InventoryForm from '../Inventory/InventoryForm'
import { fetchUnits } from '../../common/Inventory/Units'
import { createItem, ICreateITemDTO } from '../../common/Inventory/Items'
import WithholdingForm from './Purchase/WithholdingForm'
import { pdf } from '@react-pdf/renderer'
import saveAs from 'file-saver'
import WithoutHoldingPdf from './WithoutHoldingPdf'
import ISLRWithholdingPdf from './ISLRWithholdingPdf'

const server = process.env.REACT_APP_SERVER_URL
const docs_url = process.env.REACT_APP_S3_URL_DOCS

const PurchaseHistoric: React.FC<PurchaseHistoricProps> = ({
  setHeaderActions,
}) => {
  const today = DateTime.local().setLocale('es')

  const { addAlert } = useSnackBars()
  const [userConfig] = useLocalStorageState('user-config')
  const dispatch = useDispatch()

  const [
    selectedProviderForPurchase,
    setSelectedProviderForPurchase,
  ] = useState<null | any>(null)

  // const purchases = useSelector((state: RootState) => state.prch.purchases)
  // const numberOfPages = useSelector(
  //   (state: RootState) => state.prch.numberOfPages
  // )

  const [purchases, setPurchases] = useState<any>(null)
  const [numberOfPages, setNumberOfPages] = useState<number>(0)

  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const [modalFromRow, setModalFromRow] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)

  // paginación y búsqueda
  const filterForm = useForm()
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [searchModal, setSearchModal] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useState<string[]>([])
  const [selected, setSelected] = useState<any | null>(null)
  const [createPurchase, setCreatePurchase] = useState<boolean>(false)
  const [showModalEditInvoice, setShowModalEditInvoice] = useState<boolean>(
    false
  )
  const userTenantId = useSelector(
    (state: RootState) => state.auth.user['custom:tenant_id']
  )

  const [itemsToPurchaseRight, setItemsToPurchaseRight] = useState<any[]>([])

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const categories = useSelector((state: RootState) => state.ctgr.categories)

  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)
  const [showPurchase, setShowPurchase] = useState<boolean>(false)

  const [showAddPayment, setShowAddPayment] = useState<boolean>(false)

  const [showReceivedProducts, setShowReceivedProducts] = useState<boolean>(
    false
  )

  const [editInvoiceSelected, setEditInvoiceSelected] = useState<any | null>(
    null
  )

  const [deleteSelected, setDeleteSelected] = useState<string | null>(null)

  const [selectedWatchPurchase, setSelectedWatchPurchase] = useState<
    any | null
  >(null)

  const [selectedPaymentPurchase, setSelectedPaymentPurchase] = useState<
    any | null
  >(null)

  const [selectedReceivedPurchase, setSelectedReceivedPurchase] = useState<
    any | null
  >(null)

  const [onShowReturn, setOnShowReturn] = useState<boolean>(false)

  const [selectedReturn, setSelectedReturn] = useState<any | null>(null)

  const [fromReturn, setFromReturn] = useState<boolean>(false)

  const [reprintBody, setReprintBody] = useState<null | any>(null)

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const [showAddPaymentForm, setShowAddPaymentForm] = useState<boolean>(false)

  const [fastSearch, setFastSearch] = useState<string>('')

  const [showProviderModal, setShowProviderModal] = useState<boolean>(false)

  const [showAddPaymentModal, setShowAddPaymentModal] = useState<boolean>(false)

  const [showAddWithholdingModal, setShowAddWithholdingModal] = useState<boolean>(false)

  const [showAddWithholdingISLRModal, setShowAddWithholdingISLRModal] = useState<boolean>(false)

  const [payments, setPayments] = useState<any[]>([])

  const [showCreateItem, setShowCreateItem] = useState<boolean>(false)

  const [categoriesValues, setCategoriesValues] = useState<any[]>([])

  const [units, setUnits] = useState<IUnit[]>([])

  const [purchaseDate, setPurchaseDate] = useState(
    `${today.day}/${today.month}/${today.year}`
  )

  const fetchAndSetUnits = useCallback(async () => {
    const units = await fetchUnits()
    setUnits(units)
  }, [])

  const paymentsWithoutHolding = useMemo(() => {
    return payments.filter((payment) => payment.withholding === false)
  }, [payments])

  const getPdfData = (purchase: IPurchase): string[][] => {
    const response: string[][] = []
    const loads = [...purchase.invoice.movement[0].loads]
    for (const item of purchase.invoice.items) {
      const unit: IUnit = loads.find(
        (load) => load.existence.item.id === item.id
      )?.existence.item.unit || {
        id: '1',
        name: 'unit',
        abbreviatedName: 'und',
      }

      const row: string[] = []
      row.push(item.barcode || item.sku || 'Sin código')
      row.push(item.name || 'Sin nombre')
      row.push(formatAmount(item.quantity, unit))
      row.push(formatToBs(+item.cost))
      row.push(formatToBs(+item.cost * +item.quantity))
      response.push(row)
    }
    return response
  }

  const doTheFetch = async (params: string[] = [], pageNumber: number = 0) => {
    console.log('fetching')
    try {
      setLoading(true)
      const paginationParams = [
        `pageNumber=${pageNumber + 1}`,
        `pageSize=${userConfig.rowsPerPage}`,
      ]
      await dispatch(fetchPurchases(params, paginationParams))
      setCreatePurchase(false)
    } catch (error: any) {
      addAlert({
        message: error?.response?.data?.message || 'Error al cargar compras',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  useEffect(() => {
    setCategoriesValues(
      categories.map((category) => ({
        value: category?.id,
        text: category?.name,
      }))
    )
  }, [categories])

  useEffect(() => {
    fetchAndSetUnits()
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const getPurchases = async (
    params: string[] = [],
    pageNumber: number = 0,
    fastParam = fastSearch
  ): Promise<void> => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]
    setCurrentPage(pageNumber)
    setSearchParams(params)
    setFastSearch(fastParam)
    setLoading(true)

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    let response = await axios.get(
      `${server}/purchase?${[...paginationParams, ...newParams].join('&')}`
    )
    setPurchases(response.data.purchases)
    setNumberOfPages(response.data.numberOfPages)
    setLoading(false)
  }

  useEffect(() => {
    // doTheFetch(searchParams, currentPage)
    getPurchases(searchParams, currentPage)
  }, [currentPage])

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setHeaderActions({
      advancedSearch: async (value) => {
        if (typeof value === 'boolean') {
          setSearchModal(value)
          return
        }
        getPurchases(searchParams, currentPage, value)
        // if (currentPage === 0) {
        //   getPurchases([`fastSearch=${value}`])
        // } else {
        //   setSearchParams([`fastSearch=${value}`])
        //   setCurrentPage(0)
        // }
      },
      // searchAction: () => setSearchModal(true),
      cleanFilters: {
        search: () => {
          getPurchases([], 0)
          // setSearchParams([])
          // if (currentPage === 0) {
          //   getPurchases()
          // }
          // setCurrentPage(0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
      // onSearch: {
      //   placeholder: 'Buscar Compra',
      //   action: (value) => {
      //     const newSearch: string[] = []
      //     const valueWithoutSpaces = value.replace(/\s/g, ' ').trim()
      //     // const from = searchParams.find(s => s.includes("from="))
      //     // const to = searchParams.find(s => s.includes("to="))
      //     // if (from) newSearch.push(from)
      //     // if (to) newSearch.push(to)
      //     if (valueWithoutSpaces) {
      //       newSearch.push(`value=${valueWithoutSpaces}`)
      //     }
      //     // setSearchParams(newSearch)
      //     doTheFetch(newSearch)
      //   },
      //   display: true,
      //   ref: inputRef,
      //   tooltipMessage:
      //     'Puede buscar por código, documento o nombre de proveedor. Ej J8888888',
      // },
      onCustomAction: userRole === "seniat" ? [] : [
        // {
        //   title: "",
        //   icon: <BsFillCalendarWeekFill/>,
        //   buttonType: "outline",
        //   action: () => setSearchModal(true),
        //   display: true
        // },
        // {
        //   title: "",
        //   icon: <GiCancel/>,
        //   buttonType: "outline",
        //   action: () => {
        //     setSearchParams([])
        //     if (currentPage === 0) {
        //       doTheFetch()
        //     }
        //     setCurrentPage(0)
        //     inputRef.current && (inputRef.current.value = "")
        //   },
        //   display: Boolean(searchParams.length > 0)
        // },
        {
          action: async () => {
            await dispatch(fetchCategories())
            setCreatePurchase(true)
          },
          title: 'Añadir Compra',
          icon: <HiOutlinePlus />,
          buttonType: 'primary',
          display: true,
        },
      ],
    })
    return () => {
      if (inputRef && inputRef.current) {
        inputRef.current.value = ''
      }
      setHeaderActions(null)
    }
  }, [setHeaderActions, searchParams, currentPage])

  let columnsMemo = useMemo(
    () =>  {

      const columns = [
        {
          title: 'N° Factura',
          dataIndex: 'bill.code',
          key: 'bill.code',
          render: (x: any, purchase: any) => (
            <ColumnItemWrapper>
              {purchase?.bill?.code || 'N/A'}
              {/* {new Date(purchase.invoice.emissionDate).toLocaleDateString()} */}
            </ColumnItemWrapper>
          ),
        },
        {
          title: 'Fecha de compra',
          dataIndex: 'invoice.emissionDate',
          key: 'invoice.emissionDate',
          render: (x: any, purchase: any) => (
            <ColumnItemWrapper>
              {transformDate(new Date(purchase.date).toISOString())}
            </ColumnItemWrapper>
          ),
        },
        {
          title: 'Proveedor',
          dataIndex: 'provider.businessName',
          key: 'provider.businessName',
          // render: (x: any, purchase: any) => (
          //   <ColumnItemWrapper>
          //     {purchase.provider.businessName ||
          //       purchase.provider.commercial_name ||
          //       `${purchase.provider.name || ''} ${
          //         purchase.provider.surname || ''
          //       }`}
          //   </ColumnItemWrapper>
          // ),
        },
        {
          title: 'Monto total',
          dataIndex: 'cost',
          key: 'cost',
          render: (id: number, record: any) => (
            <ColumnItemWrapper>
              {`${getDenomination(record?.currency?.id)} ${formatPipe(
                record?.cost
              )}`}
            </ColumnItemWrapper>
          ),
        },
        {
          title: 'Pago',
          dataIndex: 'paidOut',
          key: 'paidOut',
          render: (x: any, purchase: any) => (
            <ColumnItemWrapper>
              {purchase.paidOut ? 'Realizado' : 'Pendiente'}
            </ColumnItemWrapper>
          ),
        },
        {
          title: 'Usuario',
          dataIndex: 'username',
          key: 'username',
          // render: (x: any, purchase: IPurchase) => (
          //   <ColumnItemWrapper>
          //     {getMissing(purchase.invoice.items)
          //       ? `${getMissing(purchase.invoice.items)}/${
          //           purchase.invoice.items.length
          //         }`
          //       : 'Completo'}
          //   </ColumnItemWrapper>
          // ),
        },
        {
          title: 'Descripción',
          dataIndex: 'desc',
          key: 'desc',
          render: (x, purchase) => {
            console.log('purchase', purchase?.description)
            return <ColumnItemWrapper>{purchase?.description}</ColumnItemWrapper>
          },
          // render: (x: any, purchase: IPurchase) => (
          //   <ColumnItemWrapper>
          //     {getMissing(purchase.invoice.items)
          //       ? `${getMissing(purchase.invoice.items)}/${
          //           purchase.invoice.items.length
          //         }`
          //       : 'Completo'}
          //   </ColumnItemWrapper>
          // ),
        },
        // {
        //   title: 'Total',
        //   dataIndex: 'cost',
        //   key: 'cost',
        //   render: (x: any, purchase: IPurchase) => (
        //     <ColumnItemWrapper>{`${purchase.invoice.total} Bs`}</ColumnItemWrapper>
        //   ),
        // },
      
      ]

      if (userRole === "seniat") {
        return columns
      } else {
        return [...columns,   {
          title: '',
          dataIndex: 'id',
          align: 'right',
          width: 50,
          key: null,
          render: (id: any, purchase: any) => {
            // const {price, data} = getMovementTotalCost(purchase)
            // const data = getPdfData(purchase)
            // const OnPrintProps: PdfViewProps = {
            //   downloadTitle: `COMPRA DE MERCANCÍA - ${'0'.repeat(
            //     6 - purchase?.id.length
            //   )}${purchase?.id}`,
            //   column_styles: { ITEM: { width: 700 }, DESCRIPCIÓN: { width: 700 } },
            //   type: 'PURCHASE',
            //   footer_render: {
            //     total: formatToBs(+purchase.invoice.total),
            //     provider:
            //       purchase.provider.businessName ||
            //       purchase.provider.comercialName ||
            //       'Sin proveedor',
            //     rif: `${purchase.provider.document.documentType}-${purchase.provider.document.document}`,
            //     warehouse:
            //       purchase.invoice.movement[0].loads[0].existence.location.name ||
            //       'Sin almacén',
            //   },
            //   title: `COMPRA DE MERCANCÍA - ${'0'.repeat(6 - purchase?.id.length)}${
            //     purchase?.id
            //   }`,
            //   columns: ['ITEM', 'DESCRIPCIÓN', 'CANT', 'VALOR UNI', 'VALOR TOTAL'],
            //   data,
            // }
            return (
              <ColumnItemWrapper floatingMenu>
                <FloatingMenu
                  visible={id === selected?.id}
                  onClose={() => setSelected(null)}
                  options={onFilterFloating(purchase, {
                    onWatchDocument: async () => {
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      
                      if (response?.data?.purchase?.bill?.document) {
                        await downloadImage(response?.data?.purchase?.bill?.document)
                      } else {
                        addAlert({
                          message: 'No se encontró el documento',
                          status: 'error',
                        })
                      }
                    },
                    onAddEditInvoice: async () => {
                      if (purchase?.bill?.id) {
                        let response = await axios.get(
                          `${server}/purchase?id=${id}`
                        )
                        // setSelected(response.data.purchase)
                        setEditInvoiceSelected(response?.data?.purchase)
                        setShowModalEditInvoice(true)
                      } else {
                        setEditInvoiceSelected(purchase)
                        setShowModalEditInvoice(true)
                      }
                    },
                    watchPurchase: async () => {
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      setSelectedWatchPurchase(response?.data?.purchase)
                      setShowPurchase(true)
                    },
                    onDeletePurchase: () => {
                      setDeleteSelected(id)
                      setShowConfirmModal(true)
                    },
                    onAddPayment: async () => {
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      setSelectedPaymentPurchase(response?.data?.purchase)
                      setShowAddPayment(true)
                    },
                    onAddReceivedProducts: async () => {
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      setSelectedReceivedPurchase(response?.data?.purchase)
                      setShowReceivedProducts(true)
                    },
                    onReturn: async () => {
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      let date = purchase.date.replace(/T.+/, '')
                      let responseRate = await axios.get<{
                        rates: IGlobalRate[]
                      }>(`${server}/finances/rate?date=${date}&currency=all`)
                      setGlobalRate(responseRate.data.rates)
                      setSelectedReturn(response?.data?.purchase)
                      setFromReturn(true)
                      setOnShowReturn(true)
                    },
                    onRetention: async () => {
                      const resp = await axios.get(`${server}/purchase?id=${id}`)
                      const respTenantInfo = await axios.get(`${server}/user/tenant`)
                      if (resp?.data?.purchase?.withholding?.tax_total === null) {
                        addAlert({
                          message: 'La compra no tiene retención',
                          status: 'error',
                        })
                        return
                      }

                      const blobValue = await pdf(
                        <WithoutHoldingPdf
                          bodyValues={resp?.data?.purchase}
                          infoAccount={respTenantInfo?.data?.tenant}
                          />
                      ).toBlob()

                      saveAs(blobValue, resp?.data?.purchase?.bill?.code ? `Retención_iva_${resp?.data?.purchase?.bill?.code}` : 'Retención_iva')

                      console.log('purchase', purchase)
                      // setSelectedRetention(purchase)
                      // setShowRetention(true)
                    },
                    onRetentionISLR: async () => {
                      const resp = await axios.get(`${server}/purchase?id=${id}`)
                      const respTenantInfo = await axios.get(`${server}/user/tenant`)
                      if (resp?.data?.purchase?.islrWithholding?.amount_withheld === null) {
                        addAlert({
                          message: 'La compra no tiene retención ISLR',
                          status: 'error',
                        })
                        return
                      }

                      const blobValue = await pdf(
                        <ISLRWithholdingPdf
                          bodyValues={resp?.data?.purchase}
                          infoAccount={respTenantInfo?.data?.tenant}
                          />
                      ).toBlob()

                      saveAs(blobValue, resp?.data?.purchase?.bill?.code ? `Retención_islr_${resp?.data?.purchase?.bill?.code}` : 'Retención_islr')
                    },
                    onReturnEdit: async () => {
                      // setFromReturn()
                      // console.log("purhcase", purchase.return)
                      let response = await axios.get(
                        `${server}/purchase?id=${id}`
                      )
                      let date = purchase.date.replace(/T.+/, '')
                      let responseRate = await axios.get<{
                        rates: IGlobalRate[]
                      }>(`${server}/finances/rate?date=${date}&currency=all`)
                      setGlobalRate(responseRate.data.rates)
                      setSelectedReturn(response?.data?.purchase)
                      // setSelectedReturn({...purchase?.return, id: purchase?.id, discount: purchase?.discount,
                      //   iva: purchase?.iva, igtf: purchase?.igtf, cost: purchase?.cost, provider: purchase?.provider, date: purchase?.date, usdCost: purchase?.usdCost})
                      setOnShowReturn(true)
                    },
                  })}
                >
                  <HiDotsVertical
                    className="cursor-pointer text-gray-400"
                    onClick={() => setSelected(purchase)}
                  />
                </FloatingMenu>
              </ColumnItemWrapper>
            )
          },
        },]
      }
    } 
    
    ,[purchases, selected]
  )

  const columns: ColumnsTable[] = [
    {
      title: 'N° Factura',
      dataIndex: 'bill.code',
      key: 'bill.code',
      render: (x: any, purchase: any) => (
        <ColumnItemWrapper>
          {purchase?.bill?.code || 'N/A'}
          {/* {new Date(purchase.invoice.emissionDate).toLocaleDateString()} */}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Fecha de compra',
      dataIndex: 'invoice.emissionDate',
      key: 'invoice.emissionDate',
      render: (x: any, purchase: any) => (
        <ColumnItemWrapper>
          {transformDate(new Date(purchase.date).toISOString())}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Proveedor',
      dataIndex: 'provider.businessName',
      key: 'provider.businessName',
      // render: (x: any, purchase: any) => (
      //   <ColumnItemWrapper>
      //     {purchase.provider.businessName ||
      //       purchase.provider.commercial_name ||
      //       `${purchase.provider.name || ''} ${
      //         purchase.provider.surname || ''
      //       }`}
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Monto total',
      dataIndex: 'cost',
      key: 'cost',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.cost
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Pago',
      dataIndex: 'paidOut',
      key: 'paidOut',
      render: (x: any, purchase: any) => (
        <ColumnItemWrapper>
          {purchase.paidOut ? 'Realizado' : 'Pendiente'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
      // render: (x: any, purchase: IPurchase) => (
      //   <ColumnItemWrapper>
      //     {getMissing(purchase.invoice.items)
      //       ? `${getMissing(purchase.invoice.items)}/${
      //           purchase.invoice.items.length
      //         }`
      //       : 'Completo'}
      //   </ColumnItemWrapper>
      // ),
    },
    {
      title: 'Descripción',
      dataIndex: 'desc',
      key: 'desc',
      render: (x, purchase) => {
        console.log('purchase', purchase?.description)
        return <ColumnItemWrapper>{purchase?.description}</ColumnItemWrapper>
      },
      // render: (x: any, purchase: IPurchase) => (
      //   <ColumnItemWrapper>
      //     {getMissing(purchase.invoice.items)
      //       ? `${getMissing(purchase.invoice.items)}/${
      //           purchase.invoice.items.length
      //         }`
      //       : 'Completo'}
      //   </ColumnItemWrapper>
      // ),
    },
    // {
    //   title: 'Total',
    //   dataIndex: 'cost',
    //   key: 'cost',
    //   render: (x: any, purchase: IPurchase) => (
    //     <ColumnItemWrapper>{`${purchase.invoice.total} Bs`}</ColumnItemWrapper>
    //   ),
    // },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: any, purchase: any) => {
        // const {price, data} = getMovementTotalCost(purchase)
        // const data = getPdfData(purchase)
        // const OnPrintProps: PdfViewProps = {
        //   downloadTitle: `COMPRA DE MERCANCÍA - ${'0'.repeat(
        //     6 - purchase?.id.length
        //   )}${purchase?.id}`,
        //   column_styles: { ITEM: { width: 700 }, DESCRIPCIÓN: { width: 700 } },
        //   type: 'PURCHASE',
        //   footer_render: {
        //     total: formatToBs(+purchase.invoice.total),
        //     provider:
        //       purchase.provider.businessName ||
        //       purchase.provider.comercialName ||
        //       'Sin proveedor',
        //     rif: `${purchase.provider.document.documentType}-${purchase.provider.document.document}`,
        //     warehouse:
        //       purchase.invoice.movement[0].loads[0].existence.location.name ||
        //       'Sin almacén',
        //   },
        //   title: `COMPRA DE MERCANCÍA - ${'0'.repeat(6 - purchase?.id.length)}${
        //     purchase?.id
        //   }`,
        //   columns: ['ITEM', 'DESCRIPCIÓN', 'CANT', 'VALOR UNI', 'VALOR TOTAL'],
        //   data,
        // }
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={id === selected?.id}
              onClose={() => setSelected(null)}
              options={onFilterFloating(purchase, {
                onWatchDocument: async () => {
                  let response = await axios.get(
                    `${server}/purchase?id=${id}`
                  )
                  
                  if (response?.data?.purchase?.bill?.document) {
                    await downloadImage(response?.data?.purchase?.bill?.document)
                  } else {
                    addAlert({
                      message: 'No se encontró el documento',
                      status: 'error',
                    })
                  }
                },
                onAddEditInvoice: async () => {
                  if (purchase?.bill?.id) {
                    let response = await axios.get(
                      `${server}/purchase?id=${id}`
                    )
                    // setSelected(response.data.purchase)
                    setEditInvoiceSelected(response?.data?.purchase)
                    setShowModalEditInvoice(true)
                  } else {
                    setEditInvoiceSelected(purchase)
                    setShowModalEditInvoice(true)
                  }
                },
                watchPurchase: async () => {
                  let response = await axios.get(`${server}/purchase?id=${id}`)
                  setSelectedWatchPurchase(response?.data?.purchase)
                  setShowPurchase(true)
                },
                onDeletePurchase: () => {
                  setDeleteSelected(id)
                  setShowConfirmModal(true)
                },
                onAddPayment: async () => {
                  let response = await axios.get(`${server}/purchase?id=${id}`)
                  setSelectedPaymentPurchase(response?.data?.purchase)
                  setShowAddPayment(true)
                },
                onAddReceivedProducts: async () => {
                  let response = await axios.get(`${server}/purchase?id=${id}`)
                  setSelectedReceivedPurchase(response?.data?.purchase)
                  setShowReceivedProducts(true)
                },
                onReturn: async () => {
                  let response = await axios.get(`${server}/purchase?id=${id}`)
                  let date = purchase.date.replace(/T.+/, '')
                  let responseRate = await axios.get<{ rates: IGlobalRate[] }>(
                    `${server}/finances/rate?date=${date}&currency=all`
                  )
                  setGlobalRate(responseRate.data.rates)
                  setSelectedReturn(response?.data?.purchase)
                  setFromReturn(true)
                  setOnShowReturn(true)
                },
                onReturnEdit: async () => {
                  // setFromReturn()
                  // console.log("purhcase", purchase.return)
                  let response = await axios.get(`${server}/purchase?id=${id}`)
                  let date = purchase.date.replace(/T.+/, '')
                  let responseRate = await axios.get<{ rates: IGlobalRate[] }>(
                    `${server}/finances/rate?date=${date}&currency=all`
                  )
                  setGlobalRate(responseRate.data.rates)
                  setSelectedReturn(response?.data?.purchase)
                  // setSelectedReturn({...purchase?.return, id: purchase?.id, discount: purchase?.discount,
                  //   iva: purchase?.iva, igtf: purchase?.igtf, cost: purchase?.cost, provider: purchase?.provider, date: purchase?.date, usdCost: purchase?.usdCost})
                  setOnShowReturn(true)
                },
              })}
            >
              <HiDotsVertical
                className="cursor-pointer text-gray-400"
                onClick={() => setSelected(purchase)}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const onFilterFloating = (purchase, options) => {
    if (purchase?.return) {
      const { onReturn, ...op } = options
      if (!purchase.paidOut) return op
      const { onAddPayment, ...rest } = op
      return rest
    }
    const { onReturnEdit, ...op } = options
    if (!purchase.paidOut) return op
    const { onAddPayment, ...rest } = op
    return rest
  }

  const onCreateItem = async (values) => {
    // const profit = +(values.profit / 100).toFixed(2)
    // const tax = +(values.tax / 100).toFixed(2) || 0
    // const price = +(values.cost * profit).toFixed(2)
    // const category = { id: +values.category }
    const fd = new FormData()

    // try {
      if (values.barcode === '' && values.sku === '') {
        addAlert({
          message: 'Especifique al menos un código de barras o un SKU',
          status: 'error',
        })
        return
      }

      if (values.barcode === values.sku) {
        addAlert({
          message: 'El código de barras y el SKU deben ser distintos',
          status: 'error',
        })
        return
      }

      // if (values.compound) {
      if (values.type === 'COMPOUND') {
        values.unit = '1'
        values.brand = ''
        values.barcode = null
      }

      values.barcode === '' && (values.barcode = null)
      values.sku === '' && (values.sku = null)

      setLoading(true)

      const {
        barcode,
        sku,
        brand,
        category,
        description,
        exempt: boolean,
        imageToDelete,
        name,
        subcategory,
        type,
        unit,
        price,
        cost,
        currency,
        ivaType
      } = values

      const newItem: ICreateITemDTO = {
        barcode,
        sku,
        brand,
        category,
        cost,
        price,
        description,
        exempt: boolean,
        imageToDelete,
        name,
        subcategory,
        type,
        unit: {
          id: unit,
        },
        currency,
        ivaType
      }

      addAlert({ message: 'Creando Articulo...', status: 'loading' })

      let response : any = {}

      if (values.image) {
        // console.log('llega...', userTenantId)
        fd.append('media', values.image)
        fd.append('fileType', 'photo')
        // values.image.name = `${userTenantId}`
        response = await createItem(newItem, true, fd, values.image, userTenantId)
        delete values.image
      } else {
        response = await createItem(newItem, false, fd)
      }

      
      setShowCreateItem(false)
      // setCreateItemModal(false)
      addAlert({ message: 'Artículo creado', status: 'success' })


      // const _values: Omit<IItem, 'id'> = {
      //   ...values,
      // }
      // const response: AxiosResponse<{
      //   status: number
      //   newItem: IItem
      // }> = await axios.post(`${server}/inventory/item`, {
      //   entity: {
      //     ..._values,
      //     unit: {
      //       id: _values.unit,
      //     },
      //   },
      // })
    //   let newItem = response.data.newItem
    //   if (values.image) {
    //     fd.append('media', values.image)
    //     fd.append('fileType', 'photo')
    //     const response2: AxiosResponse<any> = await axios.put(
    //       `${server}/media/file?idEntity=${newItem.id}&entity=item`,
    //       fd
    //     )
    //     const image = {
    //       url: response2.data.file,
    //     }
    //     newItem.images[0].url = image.url
    //     // delete values.image
    //   }
    //   // await fetchItems(searchParams, [
    //   //   `pageNumber=${currentPage + 1}`,
    //   //   `pageSize=${userConfig.rowsPerPage}`,
    //   // ])
    //   addAlert({ message: 'Articulo creado!', status: 'success' })
    //   setCreateItemModal(false)
    //   setLoading(false)
    //   setCurrentItem(newItem)
    //   setLoadItemModal(true)
    // } catch (error: any) {
    //   addAlert({
    //     message: error.response.data.message,
    //     status: 'error',
    //   })
    // } finally {
    //   setLoading(false)
    // }
  }

  const getOrderKeys = (key: string) => {
    if (key === 'provider.businessName') return ['provider', 'businessName']
    if (key === 'items') return ['load', 'items']
    if (key === 'cost') return ['cost']
    return key
  }

  const pressRow = (purchase) => {
    let providerDetails = { title: '', data: '' }
    let itemsDetails = { title: '', data: '' }
    let invoiceDetails = { title: '', data: '' }
    let noteDetails = { title: '', data: '' }
    let loadDetails = { title: '', data: '' }

    const localDataWithTabs: DataTabView[] = []

    providerDetails.title = 'Proveedor'
    providerDetails.data += `Documento: ${purchase.provider.document.documentType}-${purchase.provider.document.document}\n`
    purchase.provider.document.documentType.match(/([V]|[E]|[G]|[P])/) &&
      (providerDetails.data += `Nombres: ${purchase.provider.name}\n`)
    purchase.provider.document.documentType.match(/([V]|[E]|[G]|[P])/) &&
      (providerDetails.data += `Apellidos: ${purchase.provider.surname}\n`)
    purchase.provider.document.documentType.match(/([J]|[C])/) &&
      (providerDetails.data += `Razón Social: ${purchase.provider.businessName}\n`)
    purchase.provider.document.documentType.match(/([J]|[C])/) &&
      (providerDetails.data += `Nombre Comercial: ${purchase.provider.commercial_name}\n`)
    purchase.provider.emailproviderDetails += `Correo: ${purchase.provider.email}\n`
    purchase.provider.address.street &&
      (providerDetails.data += `Calle: ${purchase.provider.address.street}\n`)
    purchase.provider.address.avenue &&
      (providerDetails.data += `Avenida: ${purchase.provider.address.avenue}\n`)
    purchase.provider.address.building &&
      (providerDetails.data += `Edificio: ${purchase.provider.address.building}\n`)
    purchase.provider.address.neighborhood &&
      (providerDetails.data += `Sector: ${purchase.provider.address.neighborhood}\n`)
    providerDetails.data += `Ciudad: ${purchase.provider.address.city}\n`
    providerDetails.data += `Estado: ${purchase.provider.address.state}\n`
    providerDetails.data += `País: ${purchase.provider.address.country}\n`
    providerDetails.data += `Código Postal: ${purchase.provider.address.postalCode}\n`
    providerDetails.data += `Dirección Fiscal: ${purchase.provider.fiscalAddress}\n`
    providerDetails.data += `Contribuyente Especial: ${
      purchase.provider.contributing_special ? 'Sí' : 'No'
    }\n`
    purchase.provider.contributing_special &&
      (providerDetails.data += `Porcentaje de Retención: ${purchase.provider.withholding_tax}%\n`)
    for (let i = 0; i < purchase.provider.phones.length; i++) {
      if (i === 0) {
        providerDetails.data += `Telefonos:  ${
          purchase.provider.phones[i].country.dialCode ||
          purchase.provider.phones[i].country.dial_code
        } ${purchase.provider.phones[i].number}\n`
      } else {
        providerDetails.data += `\t\t\t${
          purchase.provider.phones[i].country.dialCode ||
          purchase.provider.phones[i].country.dial_code
        } ${purchase.provider.phones[i].number}\n`
      }
    }
    localDataWithTabs.push(providerDetails)

    const items = purchase.invoice
      ? purchase.invoice.items
      : purchase.invoice.items
    itemsDetails.title = 'Artículos'
    for (let item of items) {
      const missingCost = (+item.missing * +item.cost).toFixed(2)
      itemsDetails.data += `*\tCódigo de Barras: ${item.barcode}\n`
      itemsDetails.data += `\tSku: ${item.sku ? item.sku : 'Sin sku  '}\n`
      itemsDetails.data += `\tNombre: ${item.name}\n`
      itemsDetails.data += `\tCantidad: ${item.quantity}\n`
      itemsDetails.data += `\tCargado: ${item.loaded_quantity} ${
        +item.quantity > +item.loaded_quantity ? '(!)' : ''
      }\n`
      itemsDetails.data += `\tCosto Unitario: Bs ${item.cost}\n`
      itemsDetails.data += `\tCosto Total: Bs ${item.total}\n`
      itemsDetails.data += `\tCosto Faltante: Bs ${missingCost}\n\n`
    }
    localDataWithTabs.push(itemsDetails)

    if (purchase.invoice) {
      invoiceDetails.title = 'Factura'
      invoiceDetails.data += `Código: ${purchase.invoice.codeInvoice}\n`
      invoiceDetails.data += `Control: ${purchase.invoice.control}\n`
      invoiceDetails.data += `Fecha de Emisión: ${new Date(
        purchase.invoice.emissionDate
      ).toLocaleDateString()}\n`
      invoiceDetails.data += `Fecha de expiración: ${new Date(
        purchase.invoice.expirationDate
      ).toLocaleDateString()}\n`
      invoiceDetails.data += `Fecha de libro: ${new Date(
        purchase.invoice.bookDate
      ).toLocaleDateString()}\n`
      invoiceDetails.data += `Notas: ${purchase.invoice.description}\n\n`
      invoiceDetails.data += `Total Factura: Bs ${purchase.invoice.total}\n`
      invoiceDetails.data += `Total Faltante: Bs ${purchase.invoice.missingCost}\n`
      invoiceDetails.data += `Total Sugerido: Bs ${(
        +purchase.invoice.total - +purchase.invoice.missingCost
      ).toFixed(2)}\n`
      localDataWithTabs.push(invoiceDetails)
    }

    if (purchase.invoice?.movement?.length) {
      loadDetails.title = 'Cargas'
      for (const movement of purchase.invoice?.movement) {
        loadDetails.data += `* Almacén: ${
          movement.loads[0]?.existence?.location?.name || 'Sin definir'
        }\n`
        loadDetails.data += `  Fecha: ${transformDate(movement.date)}\n`
        loadDetails.data += `  Soporte: ${
          movement.purchaseDeliveryNote ? 'Nota de entrega' : 'Factura'
        }\n`
        loadDetails.data += `  Artículos:\n`
        for (const load of movement?.loads) {
          loadDetails.data += `  - ${load?.existence?.item?.name},\n`
          loadDetails.data += `    ${load?.amount} ${
            load?.existence?.item?.unit?.abbreviatedName || 'und'
          }\n`
        }
        loadDetails.data += `\n`
      }
      localDataWithTabs.push(loadDetails)
    }

    if (purchase.deliveryNote.length) {
      noteDetails.title = 'Notas'
      for (const deliveryNote of purchase.deliveryNote) {
        noteDetails.data += `* Código: ${deliveryNote.code}\n`
        noteDetails.data += `  Fecha de Emisión: ${new Date(
          deliveryNote.emissionDate
        ).toLocaleDateString()}\n`
        noteDetails.data += `  Fecha de expiración: ${new Date(
          deliveryNote.expirationDate
        ).toLocaleDateString()}\n`
        noteDetails.data += `  Fecha de libro: ${new Date(
          deliveryNote.bookDate
        ).toLocaleDateString()}\n`
        noteDetails.data += `  Notas: ${deliveryNote.notes}\n\n`
      }
      localDataWithTabs.push(noteDetails)
    }

    setDataWithTabs(localDataWithTabs)
    setModalFromRow(true)
  }

  const onSearch = (values) => {
    const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(values.from)
    values.from = new Date(yearFrom, monthFrom, dayFrom)

    const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.to)

    values.to = new Date(yearTo, monthTo, dayTo + 1)

    if (values.from.getTime() > values.to.getTime()) {
      addAlert({
        message: 'Fecha desde debe ser menor a la fecha hasta',
        status: 'error',
      })
      return
    }

    values.from = values.from.toISOString()

    values.to = values.to.toISOString()

    let params = Object.keys(values).map((key) => `${key}=${values[key]}`)
    // const valueParam = searchParams.find(s => s.includes("value="))
    // if (valueParam) params.push(valueParam)
    setSearchParams(params)
    setSearchModal(false)
    setCurrentPage(0)
    if (currentPage === 0) {
      doTheFetch(params)
    }
  }

  const onGetRate = (idCurrency: string | undefined): string => {
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  let subTotal = useMemo(() => {
    return reprintBody?.items?.reduce((a, b) => {
      return toFixed(
        +toFixed(a) +
          +toFixed(+b?.cost) *
            +toFixed(+b?.return) *
            +toFixed(+onGetRate(b?.currency?.id), 2),
        2
      )
    }, 0)
  }, [reprintBody])

  let iva = useMemo(() => {
    return reprintBody?.items.reduce((a, b) => {
      return +toFixed(
        +toFixed(a, 2) +
          +toFixed(
            +toFixed(+b?.cost, 2) *
              +toFixed(+b?.return, 2) *
              +toFixed(+onGetRate(b?.currency?.id), 2),
            2
          ) *
            (+(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') / 100),
        2
      )
    }, 0)
  }, [reprintBody])

  const ivaTotal = useMemo(() => {
    let ivaType = { GENERAL: 0.16, REDUCED: 0.15, SUMPTUARY: 0.08, EXEMPT: 0 }

    return toFixed(
      itemsToPurchaseRight.reduce((a, b) => {
        // return a + +b?.cost * +b.amount * ivaType[b?.item?.ivaType] * (b?.item?.currency?.id === '1' ? +globalRate : 1)
        return a + +b?.cost * +b.amount * ivaType[b?.item?.ivaType]
      }, 0),
      2
    )
  }, [itemsToPurchaseRight])

  return (
    <>
      {reprintBody && (
        <div style={{ height: '100vh' }}>
          <div
            className="flex items-center mt-3 mb-3"
            onClick={async () => {
              // await getSale([], 0)
              await getPurchases([], 0)
              setReprintBody(null)
            }}
          >
            <HiArrowLeft
              size={30}
              className="text-primary mr-2 cursor-pointer"
            />
            <label className="text-primary text-lg cursor-pointer">
              Regresar
            </label>
          </div>
          <PdfSale
            data={reprintBody?.items.map((item) => ({
              amount: item.return,
              description: item?.name,
              individualPrice: +item?.cost * +onGetRate(item?.currency?.id),
              totalPrice: +toFixed(
                +toFixed(+item?.cost, 2) *
                  +toFixed(+item?.return, 2) *
                  +toFixed(+onGetRate(item?.currency?.id), 2),
                2
              ),
            }))}
            subTotal={subTotal}
            descuento={reprintBody?.discount}
            igtf={reprintBody?.igtf}
            iva={iva}
            total={toFixed(+toFixed(subTotal, 2) + +toFixed(iva, 2), 2)}
            client={{
              name: reprintBody?.provider?.businessName,
              address: reprintBody?.provider?.fiscalAddress,
              phone: reprintBody?.provider?.phone,
              state: reprintBody?.provider?.state,
              city: reprintBody?.provider?.city,
              rif: `${reprintBody?.provider?.documentType}-${reprintBody?.provider?.document}`,
            }}
            paidOut={reprintBody?.paidOut}
            invoiceNumber={reprintBody?.invoice?.code}
            debitNote={reprintBody?.debitNote}
          />
        </div>
      )}

      {!reprintBody && (
        <>
          <Table
            columns={columnsMemo as any[]}
            data={purchases}
            loading={loading}
            pages={numberOfPages}
            pageSelected={currentPage}
            setPageSelected={(page) => getPurchases(searchParams, page)}
            setLoading={setLoading}
            // onPressButton={pressRow}
          />
          {/* <PurchasesSearchModal
        display={searchModal}
        onClose={() => setSearchModal(false)}
        form={filterForm}
        onSubmitValues={onSearch}
      /> */}

          <FloatingForm
            visible={searchModal}
            onClose={() => setSearchModal(false)}
            topClass="top-16"
            rightClass="right-10"
            containerClass="w-2/6"
          >
            {/* <PurchaseSearch
          form={filterForm}
          onSubmitValues={onSearch}
          onClose={() => setSearchModal(false)}
        /> */}
            <AdvancedPurchaseForm
              onCancel={() => setSearchModal(false)}
              onSubmit={(values) => {
                console.log('CLICK..', values)
                let rangeDate = values.isRangeDate
                const { isRangeDate, ...rest } = values

                if (values?.isDateSelected) {
                  const [dayFrom, monthFrom, yearFrom] = values.fromDate.split(
                    '/'
                  )
                  const [dayTo, monthTo, yearTo] = values.toDate.split('/')

                  let to = new Date(yearTo, +monthTo - 1, +dayTo + 1)

                  let newTo = to.toISOString()

                  let [year, month, day] = newTo
                    .replace(/T.+/, '')
                    .replace(/\-/g, '/')
                    .split('/')

                  values.from = `${yearFrom}-${monthFrom}-${dayFrom}`
                  values.to = `${year}-${month}-${day}`
                  rest.fromDate = values.from
                  rest.toDate = values.to
                  values.fromDate = values.from
                  values.toDate = values.to
                  // rest.from = values.from
                  // rest.to = values.to
                  // delete rest.date

                  console.log('VALUES..', values)
                }
                if (!values?.isDateSelected) {
                  delete rest.fromDate
                  delete rest.toDate
                  delete values.from
                  delete values.to
                }
                delete rest.isDateSelected
                // } else {
                //   console.log('Ver...')
                //   const [year, month, day] = getYearMonthAndDay(values.date)

                //   let toDate = new Date(year, month, day + 1)

                //   let to = transformDate(toDate.toISOString())
                //   const [yearTo, monthTo, dayTo] = getYearMonthAndDay(to)

                //   values.from = `${year}/${month}/${day}`
                //   values.to = `${yearTo}/${monthTo}/${dayTo}`
                //   rest.from = values.from
                //   rest.to = values.to
                //   delete rest.date
                //   console.log('values..', values)
                // }

                let param = Object.keys(rest).reduce((a, b) => {
                  console.log('CLICK', b)
                  if (values[b] !== '' && !rangeDate) {
                    return [...a, `${b}=${values[b]}`]
                  } else if (values[b] !== '') {
                    return [...a, `${b}=${values[b]}`]
                  }
                  return a
                }, [] as any)
                console.log('parma', param)
                // setSearchParams(param)
                getPurchases(param)
              }}
            />
          </FloatingForm>

          <ModalViewWithTabs
            display={modalFromRow}
            onClose={() => {
              setModalFromRow(false)
              setDataWithTabs([])
            }}
            dataWithTabs={dataWithTabs}
          />

          <Modal
            display={createPurchase}
            onClose={() => {
              setCreatePurchase(false)
              setSelectedProviderForPurchase(null)
              setPayments([])
            }}
            xlClasses={`xl:w-10/12 xl:h-5/6 overflow-hidden ${
              windowSize.innerWidth < 1400 ? 'modal-width modal-height' : ''
            }`}
            innerStyle={{ height: '100%' }}
            isFullHeight={true}
            // normalClasses="w-full h-full"
          >
            <Purchase
              paymentsProps={payments}
              onShowAddPayment={() => setShowAddPaymentModal(true)}
              onShowAddWithholding={() => setShowAddWithholdingModal(true)}
              onShowAddWithholdingISLR={() => setShowAddWithholdingISLRModal(true)}
              onFinish={async () => {
                await getPurchases()
                setCreatePurchase(false)
              }}
              onCreateProvider={() => {
                setShowProviderModal(true)
              }}
              onCreateItem={() => {
                setShowCreateItem(true)
              }}
              defaultProvider={selectedProviderForPurchase}
              changePurchaseDate={(value) => setPurchaseDate(value)}
              setPaymentsProps={setPayments}
              onItemsToPurchaseRightChange={(value) => {
                setItemsToPurchaseRight(value)
              }}
            />
          </Modal>

          <Modal
            display={showProviderModal}
            onClose={() => {
              setShowProviderModal(false)
            }}
          >
            <DealersForm
              onSubmit={async (values) => {
                const fd = new FormData()
                setLoading(true)
                try {
                  if (!values.id) {
                    addAlert({
                      message: 'Creando proveedor...',
                      status: 'loading',
                    })
                    const { phones, ...rest } = values
                    const [phone1, phone2] = phones
                    const _values: { provider: Omit<IDealer, 'id'> } = {
                      ...rest,
                      phone1: phone1?.number || null,
                      phone2: phone2?.number || null,
                    }
                    // console.log('_values', _values)
                    if (values.dealerFile) {
                      fd.append('media', values.dealerFile)
                      fd.append('fileType', 'pdf')
                      let response: any = await dispatch(
                        createDealer(_values, true, fd)
                      )
                      // if (currentPage === 0) {
                      //   setLoading(true)
                      //   fetchDealers(
                      //     [],
                      //     [
                      //       `pageNumber=${currentPage + 1}`,
                      //       `pageSize=${userConfig.rowsPerPage}`,
                      //     ]
                      //   )
                      //   setLoading(false)
                      // } else {
                      //   setCurrentPage(0)
                      // }
                      // setSearchParams([])
                      // await fetchDealersCall()
                      let selectedProvider = await axios.get(
                        `${server}/thirdparty/provider?id=${response?.data?.provider?.id}&pageNumber=1&pageSize=${userConfig.rowsPerPage}`
                      )
                      setSelectedProviderForPurchase(
                        selectedProvider?.data?.provider
                      )
                      addAlert({
                        message: 'Proveedor creado con éxito',
                        status: 'success',
                      })
                      // setModal(false)
                      setShowProviderModal(false)
                    } else {
                      try {
                        let response: any = await dispatch(
                          createDealer(_values, false, fd)
                        )
                        // console.log("response...", response.data.provider)
                        // setSearchProviderParams([])
                        // setProviderAndHasData(response.data.provider)
                        let selectedProvider = await axios.get(
                          `${server}/thirdparty/provider?id=${response?.data?.provider?.id}&pageNumber=1&pageSize=${userConfig.rowsPerPage}`
                        )
                        setSelectedProviderForPurchase(
                          selectedProvider?.data?.provider
                        )
                        await dispatch(
                          fetchDealers(
                            [`id=${response?.data?.provider?.id}`],
                            [
                              `pageNumber=1`,
                              `pageSize=${userConfig.rowsPerPage}`,
                            ]
                          )
                        )
                        addAlert({
                          message: 'Proveedor creado con éxito',
                          status: 'success',
                        })
                        setShowProviderModal(false)
                      } catch (err) {
                        addAlert({
                          message: 'Error al crear proveedor',
                          status: 'error',
                        })
                      }

                      // if (currentPage === 0) {
                      //   setLoading(true)
                      //   fetchDealers(
                      //     [],
                      //     [
                      //       `pageNumber=${currentPage + 1}`,
                      //       `pageSize=${userConfig.rowsPerPage}`,
                      //     ]
                      //   )
                      //   setLoading(false)
                      // } else {
                      //   setCurrentPage(0)
                      // }
                      // setSearchParams([])
                      // setModal(false)
                    }
                  } else {
                    if (values.dealerFile) {
                      fd.append('media', values.dealerFile)
                      fd.append('fileType', 'pdf')
                      addAlert({
                        message: 'Actualizando proveedor...',
                        status: 'loading',
                      })
                      const _values: { provider: IDealer } = {
                        provider: {
                          ...values,
                        },
                      }
                      await dispatch(updateDealer(_values, true, fd))
                      addAlert({
                        message: 'Proveedor actualizado con éxito',
                        status: 'success',
                      })
                      // setModal(false)
                      setShowProviderModal(false)
                    } else {
                      addAlert({
                        message: 'Actualizando proveedor...',
                        status: 'loading',
                      })
                      const _values: { provider: IDealer } = {
                        provider: {
                          ...values,
                        },
                      }
                      await updateDealer(_values, false, fd)
                      addAlert({
                        message: 'Proveedor actualizado con éxito',
                        status: 'success',
                      })
                      // setModal(false)
                      setShowProviderModal(false)
                    }
                  }
                } catch (e) {
                  addAlert({
                    message: 'Error al crear o actualizar proveedor',
                    status: 'error',
                  })
                } finally {
                  setLoading(false)
                  // setSelected(null)
                }
              }}
              onCancel={() => {
                setShowProviderModal(false)
              }}
            />
          </Modal>

          <Modal
            display={showModalEditInvoice}
            onClose={() => setShowModalEditInvoice(false)}
          >
            <EditPurchaseForm
              purchase={editInvoiceSelected}
              onSubmit={async (bill) => {
                console.log('values..', bill)
                addAlert({
                  message: 'Modificando factura...',
                  status: 'loading',
                })
                //Hacer subida de archivos aqui
                let s3InfoResponse: { value: any } = { value: {} }
                if (bill.document) {
                  await uploadToS3(
                    bill.document,
                    s3InfoResponse,
                    undefined,
                    userTenantId,
                    docs_url
                  )
                }
              
                let body = {
                  id: editInvoiceSelected?.id,
                  bill: {
                    ...bill,
                    date: dateToDB(bill?.date),
                    total: editInvoiceSelected?.cost,
                    document: bill.document
                      ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                      : null,
                  },
                }
                try {
                  await axios.patch(`${server}/purchase`, body)
                  await getPurchases()
                  setShowModalEditInvoice(false)
                  addAlert({
                    message: 'Factura modificada con éxito',
                    status: 'success',
                  })
                } catch (err) {
                  addAlert({
                    message: 'Error al modificar factura',
                    status: 'error',
                  })
                }
              }}
              onCancel={() => {
                // setSelected(null)
                setEditInvoiceSelected(null)
                setShowModalEditInvoice(false)
              }}
            />
          </Modal>

          <ModalConfirm
            title={'¿Está seguro que desea eliminar esta compra?'}
            displayConfirmModal={showConfirmModal}
            onCancel={() => setShowConfirmModal(false)}
            onConfirm={async () => {
              //Hacer peticion
              try {
                addAlert({
                  message: 'Eliminando compra',
                  status: 'loading',
                })
                await axios.delete(`${server}/purchase?id=${deleteSelected}`)
                await getPurchases()
                setShowConfirmModal(false)
                addAlert({
                  message: 'Compra eliminada satisfacoriamente',
                  status: 'success',
                })
              } catch (err) {
                addAlert({
                  message: 'Error al eliminar la compra',
                  status: 'error',
                })
              } finally {
                setShowConfirmModal(false)
              }
            }}
          />

          <Modal
            xlClasses={`xl:w-10/12 xl:h-5/6 ${
              windowSize.innerWidth < 1200 && 'modal-width modal-height'
            }`}
            innerStyle={{ height: '95%' }}
            display={showPurchase}
            onClose={() => setShowPurchase(false)}
            isFullHeight={true}
          >
            <WatchPurchase purchase={selectedWatchPurchase} />
          </Modal>

          <Modal
            xlClasses={`xl:w-8/12 ${
              windowSize.innerWidth < 1200 && 'modal-width'
            }`}
            display={showAddPayment}
            onClose={() => {
              setShowAddPayment(false)
              setSelectedPaymentPurchase(null)
            }}
            // innerStyle={{ height: '95%' }}
            // isFullHeight={true}
          >
            <AddPayments
              purchase={selectedPaymentPurchase}
              onClose={() => {
                setShowAddPayment(false)
                setSelectedPaymentPurchase(null)
              }}
              onAddPayment={() => {
                console.log('add...')
                setShowAddPaymentForm(true)
              }}
            />
          </Modal>

          <Modal
            display={showAddPaymentForm}
            onClose={() => {
              setShowAddPaymentForm(false)
            }}
            xlClasses="xl:w-4/12"
            contentStyle={{ overflow: 'initial' }}
          >
            <AddPaymentForm
              onSubmit={async (values, accounts, selectedAccount) => {
                let accountSelected = accounts.find(
                  (v) => v?.id === selectedAccount?.value
                )

                console.log('account selcted', accountSelected)
                const [year, month, day] = getYearMonthAndDay(values.date)

                values.amount = formatPipe(values?.amount, true)

                values.account = {
                  id: values.account,
                }

                values.currency = {
                  id: accountSelected?.idCurrency,
                }

                delete values.paymentType
                values.rate = 1

                if (accountSelected?.idCurrency !== '2') {
                  let response = await axios.get(
                    `${server}/finances/rate?date=${values.date}&currency=${accountSelected?.idCurrency}`
                  )
                  values.rate = response.data.rate.rate
                }

                setSelectedPaymentPurchase((prevState) => ({
                  ...prevState,
                  payments: [
                    ...prevState?.payments,
                    {
                      ...values,
                      account: {
                        ...values?.account,
                        code: accountSelected?.description,
                      },
                      newDate: dateToDB(values?.date),
                      date: new Date(year, month, day).toISOString(),
                    },
                  ],
                }))
                setShowAddPaymentForm(false)
              }}
              onClose={() => setShowAddPaymentForm(false)}
            />
          </Modal>

          <Modal
            display={showReceivedProducts}
            onClose={() => {
              setShowReceivedProducts(false)
              setSelectedReceivedPurchase(null)
            }}
            xlClasses="xl:w-4/12"
          >
            <AddReceivableProduct
              onClose={() => {
                setShowReceivedProducts(false)
                setSelectedReceivedPurchase(null)
              }}
              purchase={selectedReceivedPurchase}
              done={async () => {
                await getPurchases()
                setShowReceivedProducts(false)
                setSelectedReceivedPurchase(null)
              }}
            />
          </Modal>

          <Modal
            xlClasses={`xl:w-10/12 xl:h-5/6 ${
              windowSize.innerWidth < 1200 && 'modal-width modal-height'
            }`}
            innerStyle={{ height: '95%' }}
            isFullHeight={true}
            display={onShowReturn}
            onClose={async (fromPost, noteCode, items) => {
              if (fromPost) {
                await getPurchases(searchParams, currentPage)
              }
              console.log('Selected return...', selectedReturn)
              if (noteCode) {
                setReprintBody({
                  ...selectedReturn,
                  items,
                  invoice: { code: null },
                  debitNote: noteCode,
                })
              }
              setFromReturn(false)
              setOnShowReturn(false)
            }}
          >
            <Return
              isFromReturn={fromReturn}
              purchase={{ ...selectedReturn }}
            />
          </Modal>
        </>
      )}

      <Modal
        display={showAddPaymentModal}
        onClose={() => setShowAddPaymentModal(false)}
        xlClasses="xl:w-5/12"
        contentStyle={{ overflow: 'visible' }}
      >
        <AddPaymentFormModal
          onClose={() => setShowAddPaymentModal(false)}
          purchaseDate={purchaseDate}
          onSubmit={async (values, selectedAccount) => {
            // const [year, ]

            if (selectedAccount.account.currency !== '2') {
              let response = await axios.get(
                `${server}/finances/rate?date=${selectedAccount.date.replace(
                  /\//g,
                  '-'
                )}&currency=${selectedAccount.account.currency}`
              )

              const { rate } = response.data

              setPayments((prevState) => [
                ...prevState,
                {
                  ...selectedAccount,
                  reference: values?.reference,
                  date: values?.date,
                  amount: toFixed(+values?.amount || 0, 2),
                  rate: rate.rate,
                },
              ])
            } else {
              setPayments((prevState) => [
                ...prevState,
                {
                  ...selectedAccount,
                  reference: values?.reference,
                  date: values?.date,
                  amount: toFixed(+values?.amount || 0, 2),
                  rate: '1',
                },
              ])
            }

            console.log('VALUEs', values)
            setShowAddPaymentModal(false)
          }}
        />
      </Modal>

      <Modal
        display={showAddWithholdingModal}
        onClose={() => setShowAddWithholdingModal(false)}
      >
        <WithholdingForm
          title={'IVA'}
          fromPurchase={true}
          onClose={() => setShowAddWithholdingModal(false)}
          defaultValues={{
            amountWithheld: 0,
            withholdingPercentage: 0,
            taxBase: itemsToPurchaseRight.reduce((a, b) => a + +b.cost * +b?.amount, 0),
            excempt: 0,
            subtrahend: 0,
            taxTotal: ivaTotal,
          }}
          onSubmit={async (values) => {
            if (payments.some(v => v.account.text === 'Retención IVA')) {
              addAlert({
                message: 'La compra ya tiene retención IVA',
                status: 'error',
              })
              return
            }

            setPayments((prevState) => [
              ...prevState,
              {
                ...values,
                account: {text: 'Retención IVA', currency: '2'},
                reference: values?.voucherNumber || '',
                date: new Date().toLocaleDateString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('/'),
                amount: toFixed(+values?.amountWithheld || 0, 2),
                rate: 1,
              },
            ])
            setShowAddWithholdingModal(false)
          }}
        />
      </Modal>

      <Modal
        display={showAddWithholdingISLRModal}
        onClose={() => setShowAddWithholdingISLRModal(false)}
      >
        <WithholdingForm
          title={'ISLR'}
          fromPurchase={true}
          onClose={() => setShowAddWithholdingISLRModal(false)}
          defaultValues={{
            amountWithheld: 0,
            withholdingPercentage: 0,
            taxBase: itemsToPurchaseRight.reduce((a, b) => a + +b.cost * +b?.amount, 0),
            excempt: 0,
            subtrahend: 0,
            taxTotal: ivaTotal,
          }}
          onSubmit={async (values) => {
            if (payments.some(v => v.account.text === 'Retención ISLR')) {
              addAlert({
                message: 'La compra ya tiene retención ISLR',
                status: 'error',
              })
              return
            }

            setPayments((prevState) => [
              ...prevState,
              {
                ...values,
                account: {text: 'Retención ISLR', currency: '2'},
                reference: values?.voucherNumber || '',
                date: new Date().toLocaleDateString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                }).split('/').join('/'),
                amount: toFixed(+values?.amountWithheld || 0, 2),
                rate: 1,
              },
            ])
            setShowAddWithholdingISLRModal(false)
          }}
        />
      </Modal>

      <Modal display={showCreateItem} onClose={() => setShowCreateItem(false)}>
        <InventoryForm
          submitting={loading}
          categoriesValues={categoriesValues}
          onSubmit={onCreateItem}
          onClose={() => setShowCreateItem(false)}
          units={units.map((unit) => ({ value: unit.id, text: unit.name }))}
          categories={categories}
        />
      </Modal>
    </>
  )
}

export default PurchaseHistoric

interface PurchaseHistoricProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}
